<template>
  <div class="team-find">
    <BaseModalContent
      :dynamic="true"
      :closable="false"
      @close="$emit('close')">
      <h2 class="text-bold text-size-h2 mb-s">Задания повышенной сложности</h2>
      <div class="typography mb-m">
        <p>
          В&nbsp;некоторых предметах вы&nbsp;можете выбрать более сложный
          вариант заданий&nbsp;&mdash; за&nbsp;10&minus;11&nbsp;класс. При
          выборе повышенной сложности вы&nbsp;будете соревноваться
          с&nbsp;другими участниками 10&minus;11&nbsp;класса.
        </p>
        <p>
          До&nbsp;окончания&nbsp;I отборочного этапа вы&nbsp;можете вернуться
          к&nbsp;более простым заданиям, если поймете, что это необходимо.
        </p>
        <p><strong>Что важно знать:</strong></p>
        <ul>
          <li>
            <strong>Все предметы профиля станут более сложными:</strong> нельзя
            решать один предмет за&nbsp;8&ndash;9&nbsp;класс,
            а&nbsp;второй&nbsp;&mdash; за&nbsp;10&ndash;11.
          </li>
          <li>
            <strong>Подведение итогов:</strong> в&nbsp;зачет пойдет тот уровень,
            который будет выбран для данного профиля на&nbsp;момент завершения
            I&nbsp;этапа: 23&nbsp;октября в&nbsp;12:00&nbsp;МСК. После этого
            снизить сложность заданий будет нельзя.
          </li>
          <li>
            <strong>Следующие этапы:</strong> если вы&nbsp;пройдете
            в&nbsp;следующие этапы, то&nbsp;также будете выполнять задания
            за&nbsp;10&ndash;11&nbsp;класс, в&nbsp;том числе на&nbsp;предметном
            туре финала.
          </li>
        </ul>
        <p v-if="currentStage">
          Выбрать задания повышенной сложности для профиля &laquo;{{
            profile.title
          }}&raquo;?
        </p>
        <p v-else>
          Изменить эту настройку можно на странице Профиля, в блоке с Заданиями.
        </p>
      </div>
      <template v-if="currentStage">
        <BaseButton @click="handleSetTrack(upperTrack)"
          >Выбрать 10−11 класс</BaseButton
        >&emsp;
        <BaseButton
          theme="primary-border"
          @click="handleSetTrack(lowerTrack)"
          >Оставить 8−9 класс</BaseButton
        >
      </template>
      <BaseButton
        v-else
        @click="$emit('close')"
        >Закрыть</BaseButton
      >
    </BaseModalContent>
  </div>
</template>

<script>
import { INDIVIDUAL_STAGE, LOW_SCHOOL_ALIAS, SCHOOL_ALIAS } from "@/constants";
import { request } from "@/services/api";
/**
 * Модалка с объяснением про уровни профиля (для 8-9 классов)
 * И с возможность выбора `prefered_next_step_track` у профиля
 * Если пользователь выбирает старший трек, то ему должны быть доступны
 * Активности как для 8-9 так и для 10-11 классов.
 * Если выбирает младший трек - то только активности для 8-9
 */

export default {
  name: "ProfieTrackSelectModal",
  props: {
    profileId: {
      type: Number,
    },
  },
  computed: {
    profile() {
      return this.$store.state.profile.profiles[this.profileId];
    },
    currentStage() {
      return this.$store.state.participant.profiles?.find(
        (participantProfile) => {
          return (
            participantProfile.profile_id === this.profileId &&
            participantProfile.stage === INDIVIDUAL_STAGE
          );
        }
      );
    },
    upperTrack() {
      return Object.values(this.$store.state.tracks)?.find(
        (n) => n.alias === SCHOOL_ALIAS
      )?.id;
    },
    lowerTrack() {
      return Object.values(this.$store.state.tracks)?.find(
        (n) => n.alias === LOW_SCHOOL_ALIAS
      )?.id;
    },
  },
  methods: {
    /**
     * Устанавливает предпочтительный трек для
     * выбранного профиля пользователя
     * @params {Number} track_id
     */
    async handleSetTrack(track_id) {
      if (!track_id) return;
      try {
        await request({
          method: "PATCH",
          url: `/profiles/${this.profileId}`,
          data: {
            stage: INDIVIDUAL_STAGE,
            prefered_next_step_track: track_id,
          },
        });
        this.$store.commit("participant/CHANGE_PROFILE", {
          ...this.currentStage,
          prefered_next_step_track: this.$store.state.tracks[track_id],
        });
      } catch (error) {
        this.showErrorModal({
          content: "Не удалось сохранить выбор.",
          message: error.message,
        });
      }
      this.$emit("close");
    },
  },
};
</script>

<style></style>
